import React from 'react'
import { Outlet, Link, useLocation } from 'react-router-dom'
import { Container, Nav, Navbar, Badge } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons'
import NavDropdown from 'react-bootstrap/NavDropdown'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import logo from 'assets/MainLogo/Navy/ThirdLine Main Logo Navy.svg'
import './admin.css'

const analyticsLinks = [
  { to: '/admin/analytics-data', label: 'Analytics' },
  { to: '/admin/sections', label: 'Modules' },
  { to: '/admin/table-columns', label: 'Table Columns' },
  { to: '/admin/systems', label: 'Systems' }
]

const accessManagementLinks = [
  { to: '/admin/permissions', label: 'Permissions' },
  { to: '/admin/data-accesses', label: 'Data Accesses' },
  { to: '/admin/issues', label: 'Issues' }
]

const AdminLayout = () => {
  const location = useLocation()

  const isActive = (path) => {
    return location.pathname.startsWith(path)
  }

  const isGroupActive = (links) => {
    return links.some(({ to }) => isActive(to))
  }

  return (
    <div className="admin-layout">
      <ToastContainer position="top-right" />
      <Navbar expand="lg" className="admin-navbar mb-4" style={{ backgroundColor: '#dee2e6' }}>
        <Container fluid>
          <Link to="/admin" className="navbar-brand d-flex align-items-center gap-2">
            <img
              src={logo}
              alt="ThirdLine"
              className="admin-navbar__logo"
            />
            <Badge pill className="admin-navbar__badge">Admin</Badge>
          </Link>
          <Navbar.Toggle aria-controls="admin-navbar" />
          <Navbar.Collapse id="admin-navbar">
            <Nav className="me-auto align-items-center">
              <Nav.Link
                as={Link}
                to="/admin/usage"
                className={`admin-navbar__link ${isActive('/admin/usage') ? 'active' : ''}`}
              >
                Usage
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/admin/municipalities"
                className={`admin-navbar__link ${isActive('/admin/municipalities') ? 'active' : ''}`}
              >
                Municipalities
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/admin/users"
                className={`admin-navbar__link ${isActive('/admin/users') ? 'active' : ''}`}
              >
                Users
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/admin/data-pipelines"
                className={`admin-navbar__link ${isActive('/admin/data-pipelines') ? 'active' : ''}`}
              >
                Data Pipelines
              </Nav.Link>
              <NavDropdown
                title="Analytics"
                className={`admin-navbar__dropdown ${isGroupActive(analyticsLinks) ? 'active' : ''}`}
              >
                {analyticsLinks.map(({ to, label }) => (
                  <NavDropdown.Item
                    key={to}
                    as={Link}
                    to={to}
                    active={isActive(to)}
                  >
                    {label}
                  </NavDropdown.Item>
                ))}
              </NavDropdown>
              <NavDropdown
                title="Access Management"
                className={`admin-navbar__dropdown ${isGroupActive(accessManagementLinks) ? 'active' : ''}`}
              >
                {accessManagementLinks.map(({ to, label }) => (
                  <NavDropdown.Item
                    key={to}
                    as={Link}
                    to={to}
                    active={isActive(to)}
                  >
                    {label}
                  </NavDropdown.Item>
                ))}
              </NavDropdown>
              <Nav.Link
                as={Link}
                to="/admin/style-guide"
                className={`admin-navbar__link ${isActive('/admin/style-guide') ? 'active' : ''}`}
              >
                Style Guide
              </Nav.Link>
            </Nav>
            <Nav className="align-items-center">
              <Nav.Link as={Link} to="/" className="admin-navbar__link admin-navbar__link--exit">
                <FontAwesomeIcon icon={faSignOutAlt} className="me-1" />
                Exit
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <Container fluid className="admin-content">
        <Outlet />
      </Container>
    </div>
  )
}

export default AdminLayout
